module.exports = __webpack_public_path__ + "/res/logo-69d9c1d069e0c8c485bd5e9c757f5f46.png";


//////////////////
// WEBPACK FOOTER
// ./core/src/components/LuminopiaLogo/logo.png
// module id = 1223
// module chunks = 0